import { useEffect, useMemo } from "react";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import TableWidget from "../../../components/tables/TableWidget";
import { fetchUndeliveredPackagesCentralizer } from "../../../redux/api/raports.api";
import {
  getClients,
  getWorkingRoutesNodes,
} from "../../../redux/api/expedition.api";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { clearWorkingRoutesNodes } from "../../../redux/reducer/expedition.reducer";
import { dateForDatabase } from "../../../utils/dateAndTime";
import {
  getUndeliveredPackagesCentralizerTableData,
  undeliveredPackagesCentralizerTableHeader,
} from "./components/tableConfigs/undeliveredPackagesCentralizerTableConfig";

function UndeliveredPackagesCentralizer() {
  const dispatch = useAppDispatch();
  const {
    raports: {
      undeliveredPackagesCentralizer: {
        data: {
          data: undeliveredPackagesCentralizerData,
          total: totalUndeliveredPackagesCentralizer,
        },
        isLoading: isLoadingUndeliveredPackagesCentralizer,
      },
    },
  } = useAppSelector((state) => ({
    raports: state.raports,
  }));

  const {
    expedition: {
      clients: { data: clientsData },
      workingRoutesNodes: {
        data: { data: clientsNodesData },
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
  }));

  useEffect(() => {
    dispatch(getWorkingRoutesNodes({ page: 1, perPage: 50 }));
    dispatch(getClients({ page: 1, perPage: 99999 }));

    return () => {
      dispatch(clearWorkingRoutesNodes());
    };
  }, [dispatch]);

  const tableHeader = useMemo(
    () =>
      undeliveredPackagesCentralizerTableHeader.map((item) => {
        if (item.value === "client") {
          const clientsDropdown =
            clientsData?.data.map(({ denumireClient, idClient }) => ({
              label: denumireClient,
              value: idClient || 0,
            })) ?? [];

          return {
            ...item,
            withFilter: [{ label: "Toate", value: "all" }, ...clientsDropdown],
          };
        }

        if (item.value === "nodDestinatie") {
          const nodesDropdown =
            clientsNodesData?.map(({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            })) ?? [];

          return {
            ...item,
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
          };
        }

        return item;
      }),
    [clientsData?.data, clientsNodesData],
  );

  const handleScannedPackagesTableActions = (action: TableActions) => {
    dispatch(
      fetchUndeliveredPackagesCentralizer({
        page: action.tablePagination.page,
        perPage: action.tablePagination.rowsPerPage,
        doc_trans: action.tableSearch?.doc_trans,
        client: action.tableSearch?.client,
        pctpreluare: action.tableSearch?.pctpreluare,
        pctlivrare: action.tableSearch?.pctlivrare,
        adresa: action.tableSearch?.adresa,
        nodDestinatie: action.tableSearch?.nodDestinatie,
        tip_eroare: action.tableSearch?.tip_eroare,
        data_crearii: dateForDatabase(action.tableSearch?.data_crearii),
      }),
    );
  };

  return (
    <TableWidget
      tableTitle="Centralizator colete nelivrate"
      tableHeaderData={tableHeader}
      tableItemsData={getUndeliveredPackagesCentralizerTableData(
        undeliveredPackagesCentralizerData,
      )}
      totalItems={totalUndeliveredPackagesCentralizer}
      tableLoading={isLoadingUndeliveredPackagesCentralizer}
      handleTableActions={handleScannedPackagesTableActions}
      borderedRow
    />
  );
}

export default UndeliveredPackagesCentralizer;
